<template>


<div   class="calculation_node raised_item" :ref="'node'+node.id" :id="'node'+node.id" :style="offsets">

<div class="calculation_node_left_notch calculation_node_notch" :class="leftnotch_active" :id="'left_notch'+node.id" 
v-if="node.type!=='variable' && node.type!=='section' && node.type!=='inputfield' && node.type!=='customattribute_value' && node.type!=='customcalculation'"></div>

<div class="calculation_node_right_notch calculation_node_notch" :class="rightnotch_active" :id="'right_notch'+node.id" 

v-if="node.type!=='customattribute'"></div>
<!-- header-->
<div class="calculation_node_header" :class="bgcolor">
<div v-tooltip.top="node.title" class="calculation_node_header_text" :id="'handle'+node.id">{{node.title}}</div>
<div class="calculation_node_header_icon" @click="showContent">	
<span class="material-icons-outlined md-30 text-white">expand_more</span>
</div>
</div>
<!-- header-->


<!-- body-->
<div class="calculation_node_body calculation_node_body_high " :class="showclass">


	<div class="calculation_node_content ">
	<div class="calculation_node__animate animate_class_delay">

	<div class="calculation_node_content_inner_high">
	<small class="font-medium line-height-1" v-if="node.type=='variable' || node.type=='section' || node.type=='inputfield' || node.type=='customattribute_value' || node.type=='customcalculation'">{{node.title}}</small>


	<!-- name -->
	<template 
	v-if="node.type!=='variable' && 
		node.type!=='equation' && 
		node.type!=='customattribute' && 
		node.type!=='section' && 
		node.type!=='customattribute_value' && 
		node.type!=='customcalculation' && 
		node.type!=='inputfield' 
		">
		

		<InputText  type="text" v-model="node.title" class="w-full p-inputtext-sm animate_class" placeholder="İsim" v-on:keyup.enter="nameChanged"   />
		<hr>


	</template>

	<!-- name -->


	<!-- calculation -->
	<template 
	v-if="node.type!=='variable' && 
		node.type!=='equation' && 
		node.type!=='customattribute' && 
		node.type!=='section' && 
		node.type!=='customattribute_value' && 
		node.type!=='customcalculation' && 
		node.type!=='inputfield'&& 
		node.type!=='conditional_logic'
		">


		<!--
		<template v-if="input1">
			<template v-if="this.node.input1.type=='connection'">
				 <div class="flex align-items-center justify-content-start "> 
				<small class="font-medium line-height-2 text-primary w-full"
				v-tooltip.left="{ value: input1.title, disabled: false,class: 'custom-top-tooltip' }"
				>1. değişken</small>
				<Button icon="pi pi-trash" class="p-button-rounded p-button-text p-button-sm p-button-danger  py-0" @click="deleteConnection('input1')"/>
			</div>
			</template>
			<template v-else>
				<div class="flex align-items-center justify-content-start "> 
				 <InputNumber inputClass="w-full p-inputtext-sm py-1"   v-model="input1val" mode="decimal" :minFractionDigits="0" :maxFractionDigits="5" @input="nodeinputValueChanged($event,'input1')"/>
				 <Button icon="pi pi-trash" class="p-button-rounded p-button-text p-button-sm p-button-danger  py-0" @click="deleteValue('input1')"/>
				</div>
			</template>			
		</template>
		<template v-else>
			<InputNumber inputClass="w-full p-inputtext-sm py-1"  v-model="input1val" mode="decimal" :minFractionDigits="0" :maxFractionDigits="5" @input="nodeinputValueChanged($event,'input1')" />
		</template>
		<template >
			<div class="flex align-items-center justify-content-center my-1">            
           <Button  icon="pi pi-sort-alt"  class=" p-button-primary p-button-outlined  p-button-sm  "  @click="swapInputs"/>
        </div>
		</template>
		<template v-if="input2">
			<template v-if="this.node.input2.type=='connection'">
				 <div class="flex align-items-center justify-content-start "> 
				<small class="font-medium line-height-2 text-primary w-full"
				v-tooltip.left="{ value: input2.title, disabled: false,class: 'custom-top-tooltip' }"
				>2. değişken</small>
				<Button icon="pi pi-trash" class="p-button-rounded p-button-text p-button-sm p-button-danger  py-0" @click="deleteConnection('input2')"/>
			</div>
			</template>
			<template v-else>
				<div class="flex align-items-center justify-content-start ">
				 <InputNumber inputClass="w-full p-inputtext-sm py-1"   v-model="input2val" mode="decimal" :minFractionDigits="0" :maxFractionDigits="5" @input="nodeinputValueChanged($event,'input2')"/>
				 <Button icon="pi pi-trash" class="p-button-rounded p-button-text p-button-sm p-button-danger  py-0" @click="deleteValue('input2')"/>
				</div>
			</template>			
		</template>
		<template v-else>
			<InputNumber inputClass="w-full p-inputtext-sm py-1"  v-model="input2val" mode="decimal" :minFractionDigits="0" :maxFractionDigits="5" @input="nodeinputValueChanged($event,'input2')" />
		</template>

		
		 
		-->
		<div class="grid" style="overflow-x: hidden;">
			<div class="col-6"><h4 class="text-primary my-1">Öğeler</h4></div>

			<template 
			v-if="node.type=='subtraction' || 
				node.type=='division' || 
				node.type=='addition' || 
				node.type=='multiplication'
				">

			<div class="col-6 flex justify-content-end" v-if="!adding_variable">
			<Button icon="pi pi-plus" v-tooltip.top="'Değer Ekle'" class="p-button-rounded p-button-text p-button-sm p-button-primary  py-0 " @click="addValue"/>			
			</div>

			<template v-if="adding_variable">
				<div class="col-6"></div>
				<div class="col-8 py-0">	
					<InputText  
					type="number" 
					placeholder="Sayısal değeri" 
					v-model="new_value" 
					v-on:keyup.enter="submitNewValue"
					v-on:keyup.esc="cancelAddValue"
					class="w-full p-inputtext-sm"/>		
				</div>
				<div class="col-4 py-0">
					<div class="grid-nogutter flex justify-content-end">
						<div class="col-6">
							<Button icon="pi pi-check" class="p-button-rounded p-button-text p-button-sm p-button-success py-0 mr-1" @click="submitNewValue"/>				
						</div>
						<div class="col-6">
							<Button icon="pi pi-times" class="p-button-rounded p-button-text p-button-sm p-button-danger py-0" @click="cancelAddValue"/>				
						</div>
					</div>
				</div>
				<div class="col-12 py-0 my-0"><hr></div>
				
			</template>
			</template>

			
			



			<div class="col-12">
				<ScrollPanel :style="'width: 100%; height: '+scrollpanelheight+'px;'">
					<draggable 
					v-model="inputs"
					class="grid" 
					@start="start" 
					@end="end" 
					@change="change"
					handle=".handle"
					v-bind="dragOptions"
					item-key="id">

					<template #item="{element,index}">	
						<div class="grid " >
							<div class="col-2 handle">	
							<span class="material-symbols-outlined">
							drag_handle
							</span>
							</div>
							<div class="col-8 py-0 mt-3">
								<p class="text-primary text-sm m-0 the_elipsis" v-tooltip.left="element.title">{{element.title}}</p>
							</div>
							<div class="col-2 flex align-items-center py-0">
								<Button icon="pi pi-trash" class="p-button-rounded p-button-text p-button-sm p-button-danger  py-0 mt-2" @click="deleteConnection(element,index)"/>
							</div>
							<div class="col-12 py-0" v-if="index+1 < inputs.length"><hr></div>
						</div>

					</template>


				</draggable>


				
			</ScrollPanel>

			</div>
		</div>
		
		


		

		

		


	</template>

<!-- calculation -->


<!-- customattribute -->

	<template v-if="node.type=='customattribute'">
		<label>Alt Limit</label>
	<InputNumber inputClass="w-full p-inputtext-sm   mb-2"   v-model="node.condition_action.low_point" mode="decimal" :minFractionDigits="0" :maxFractionDigits="5"  />
	<label>Üst Limit</label>
	<InputNumber inputClass="w-full p-inputtext-sm   mb-2"   v-model="node.condition_action.high_point" mode="decimal" :minFractionDigits="0" :maxFractionDigits="5"  />
	<label>Özel Nitelik</label>
	<Dropdown  v-model="node.condition_action.customattribute" :options="$store.state.calculations.customattributes" optionLabel="name" optionValue="id" class=" p-inputtext-sm w-full mb-2" @change="testchange"/>

	<template v-if="selected_customattribute && selected_customattribute.type=='select'">
		<label>Seçenek</label>
		<Dropdown  v-model="node.condition_action.value" :options="selected_customattribute.options" optionLabel="name" optionValue="id" class=" p-inputtext-sm w-full " />
	</template>
	</template>

<!-- customattribute -->

<!-- conditional_logic -->
<template v-if="node.type=='conditional_logic'">


<ConditionalLogic :inputs="inputs" :node="node"></ConditionalLogic>



</template>
<!-- conditional_logic -->






	</div>


	<div class="node_footer flex align-items-center justify-content-end">
		<Button   v-tooltip.bottom="'Bağlantıyı Kopar'" class=" p-button-primary p-button-outlined  p-button-sm p-0 m-0 mr-2" @click="severeConnections">
			<span class="material-symbols-outlined md-17 mr-2 ml-2">
		line_start_circle
		</span>
		</Button>
		<Button  icon="pi pi-trash"  v-tooltip.bottom="'Sil'" class=" p-button-danger p-button-outlined  p-button-sm p-0 m-0" @click="deleteNode"/>
	</div>
	</div>
	</div>



</div>
<!-- body-->
<ConfirmPopup group="deletenode"></ConfirmPopup>
<ConfirmPopup group="severeconnections"></ConfirmPopup>


</div>


</template>

<script>
const conditionmodel = {
		id:null,
    type:null,//inputfield,customattribute
    comparison_type:null,
    selected_input:null,
    comparison_input:null,
    text_val:null,
    numerical_val:null,
    execution_type:null,
    operator:null,
	}
import ConditionalLogic from "./ConditionalLogic"
export default {

  name: 'CalculationNode',
  props:["node"],
  data () {
    return {
    	input1val:null,
    	input2val:null,
    	active:false,
    	show_content:false,  
    	selected_customattribute:null,
    	conditionoperators:[
    	{name:">",id:"lowerthan",text:"Küçüktür"},
    	{name:"=",id:"equalto",text:"Eşittir"},
    	{name:"<",id:"higherthan",text:"Büyüktür"},
    	],
    	condition_action_operators:[
    	{name:"Puan Ekle",id:"add_points"},
    	{name:"Puan Çıkar",id:"remove_points"},
    	{name:"Sabit Puan",id:"set_points"},
    	],
    	adding_variable:false,
    	new_value:null,
    	inputs:[],
    }
  },
  components:{ConditionalLogic},
  watch:{
  	node()
  	{
  		if(this.node.input1 && this.node.input1.type=="value")
  		{
  			this.input1val = this.node.input1.value
  		}

  		if(this.node.input2 && this.node.input2.type=="value")
  		{
  			this.input2val = this.node.input2.value
  		}
  	},
  	customattribute_selected(newval)
  	{
  		console.log("customattribute_selected")
  	},	
  	inputs_length()
  	{
  		this.resolveInputs()
  	}
  },
  computed:{
  	dragOptions() {
      return {
        animation: 200,
        disabled: false,
        ghostClass: "ghost"
      };
    },
  	scrollpanelheight()
  	{
  		if(this.adding_variable)
  		{
  			return 90
  		}
  		return 130
  	},
  	customattribute_selected()
  	{
  		if(this.node.condition_action && this.node.condition_action.customattribute)
  		{
  			return this.node.condition_action.customattribute
  		}
  		return null
  		
  	},
  	inputs_length()
  	{
  		return this.node.input.length
  	},
  	input1()
  	{
  		
  		if(this.node.input1)
  		{
  			if(this.node.input1.type=="connection")
  			{
  				let connections = this.$store.state.calculations.connections
	  			let nodes = this.$store.state.calculations.nodes
	  			let connected = connections.find((item)=>{return item.id == this.node.input1.connection_id})
	  			if(connected)
	  			{
	  				let from = nodes.find((item)=>{return item.id == connected.from})
	  				return from
	  			}
	  			else
	  			{
	  				let node_ind = nodes.findIndex((item)=>{return item.id == this.node.id})
	  				nodes[node_ind].input1 = null
	  				this.$store.dispatch('calculations/setNodes',nodes)
	  				return null
	  			}
	  			
  			}
  			else
  			{
  				this.input1val = this.node.input1.value
  				return this.node.input1.value
  			}
  			
  		}
  		else
  		{
  			return null
  		}  		
  	},

  	input2()
  	{
  		if(this.node.input2)
  		{
  			if(this.node.input2.type=="connection")
  			{
  				let connections = this.$store.state.calculations.connections
	  			let nodes = this.$store.state.calculations.nodes
	  			let connected = connections.find((item)=>{return item.id == this.node.input2.connection_id})
	  			if(connected)
	  			{
	  				let from = nodes.find((item)=>{return item.id == connected.from})
	  				return from
	  			}
	  			else
	  			{
	  				let node_ind = nodes.findIndex((item)=>{return item.id == this.node.id})
	  				nodes[node_ind].input2 = null
	  				this.$store.dispatch('calculations/setNodes',nodes)
	  				return null
	  			}
  			}
  			else
  			{
  				this.input2val = this.node.input2.value
  				return this.node.input2.value
  			}
  			
  		}
  		else
  		{
  			return null
  		}  				
  	},
  	coordinates()
  	{
  		if(this.show_content)
  		{
  			return "left:"+this.node.top+"px;left:"+this.node.left+"px;z-index:100"
  		}
  		else
  		{
  			return "left:"+this.node.top+"px;left:"+this.node.left+"px;"
  		}
  		
  	},
  	offsets()
  	{
  		
  		if(this.show_content)
  		{
  			return "left:"+this.node.offsetX+"px;top:"+this.node.offsetY+"px;z-index:100"
  		}
  		else
  		{
  			return "left:"+this.node.offsetX+"px;top:"+this.node.offsetY+"px"
  		}
  		
  	},
  	showclass()
  	{
  		if(this.show_content)
  		{
  			return "open"
  		}
  		else
  		{
  			return ""
  		}
  	},
  	bgcolor()
  	{
  		if(this.node.type=="variable")
  		{
  			return "calculation_node_variable"
  		}
  		if(this.node.type=="customattribute_value")
  		{
  			return "calculation_node_variable_1"
  		}
  		if(this.node.type=="customcalculation")
  		{
  			return "calculation_node_variable_2"
  		}
  		if(this.node.type=="conditional_logic")
  		{
  			return "calculation_node_variable_3"
  		}
  		if(this.node.type=="section")
  		{
  			return "logical_node_variable"
  		}
  		if(this.node.type=="inputfield")
  		{
  			return "calculation_node_variable"
  		}
  		if(this.node.type=="equation")
  		{
  			return "calculation_node_equation"
  		}

  		if(this.node.type=="customattribute")
  		{
  			return "calculation_node_condition"
  		}
  		if(this.node.type!=="variable" 
  			|| this.node.type!=="equation" 
  			|| this.node.type!=="condition"
  			|| this.node.type!=="section"
  			|| this.node.type!=="inputfield")
  		{
  			return "calculation_node_calculation"
  		}
  	},
  	rightnotch_active()
  	{
  		if(this.$store.state.calculations.fromnode && this.$store.state.calculations.fromnode.id==this.node.id)
  		{
  			return "full"
  		}
  		else
  		{
  			let connections = this.$store.state.calculations.connections
  			for (let i = 0; i <connections.length; i++) {
  				if(connections[i].from == this.node.id)
  				{
  					return "full"
  				}
  			}
  			return ""
  		}
  	},
  	leftnotch_active()
  	{
  		if(this.$store.state.calculations.tonode && this.$store.state.calculations.tonode.id==this.node.id)
  		{
  			return "full"
  		}
  		else
  		{
  			let connections = this.$store.state.calculations.connections
  			for (let i = 0; i <connections.length; i++) {
  				if(connections[i].to == this.node.id)
  				{
  					return "full"
  				}
  			}
  			return ""
  		}
  	}

  },
  mounted()
  {

    console.log(this.node)
  	if(this.customattribute_selected)
  	{
  		this.testchange()
  	}




  },
  methods:{
  	resolveInputs()
  	{
  		let inputs = []
  		if(this.node.input && this.node.input.length)
  		{
  			let connections = this.$store.state.calculations.connections
	  		let nodes = this.$store.state.calculations.nodes
	  		for(let input of this.node.input)
	  		{
	  			if(input.type=="connection")
	  			{
	  				let connected = connections.find((item)=>{return item.id == input.connection_id})
		  			if(connected)
		  			{
		  				let from = nodes.find((item)=>{return item.id == connected.from})
		  				if(from)
		  				{
		  					inputs.push(from)
		  				}
		  			}
	  			}
	  			if(input.type=="value")
	  			{
	  				let obj = {
	  					title:"Değer: "+input.value.toLocaleString('tr-TR', { maximumFractionDigits: 8 }),
	  					id:"value"
	  				}
	  				inputs.push(obj)
	  			}

	  			
	  		}
  		}
  		this.inputs = inputs
  	},
  	end(event)
    { 
      this.drag = false
    },
    start(event)
    {
      this.drag = true
    },
    rewriteConnections()
    {
    	let connections = this.$store.state.calculations.connections
    	let new_inputs = []
    	console.log("rewriteConnections")    	
    	for(let input of this.inputs)
    	{
    		let obj
    		if(input.id=="value")
    		{
    			let value = input.title.replace("Değer: ","")
    			value = parseFloat(value) 
    			obj = {value:value,type:"value"}
    		}
    		else
    		{
    			let connection = connections.find(item=>item.from == input.id.toString() && item.to == this.node.id)
	    		if(connection)
	    		{
	    			obj = {connection_id:connection.id,type:"connection"}
	    		}
    		}
    		new_inputs.push(obj)    		
    	}
    	console.log("new_inputs")
    	console.log(new_inputs)
    	this.node.input = new_inputs
    },
    change(event)
    {
      console.log(event)  
      this.rewriteConnections()    
      let nodes = this.$store.state.calculations.nodes
  		let ind = nodes.findIndex((item)=>{return item.id == this.node.id})
  		nodes[ind] = this.node
  		this.$store.dispatch('calculations/setNodes',nodes)
    },
  	addValue()
  	{
  		if(this.node.type=="subtraction" || this.node.type=="subtraction")
  		{

  		}
  		this.adding_variable = true
  	},
  	cancelAddValue()
  	{
  		this.adding_variable = false
  		this.new_value = null
  	},
  	submitNewValue()
  	{
  		if(!this.new_value)
  		{
  			return false
  		}
  		if(this.node.input.length==2)
  		{
  			if(this.node.type=="subtraction" ||this.node.type=="division")
  			{
  				this.cancelAddValue()
  				this.showMessage("error",this.node.type.toUpperCase()+" hesaplama öğesine en fazla iki değişken iliştirilebilir","")
  				return false
  			}
  		}
  		let input_item = {value:this.new_value,type:"value"}
			this.node.input.push(input_item)
			let nodes = this.$store.state.calculations.nodes
  		let ind = nodes.findIndex((item)=>{return item.id == this.node.id})
  		nodes[ind] = this.node
  		this.$store.dispatch('calculations/setNodes',nodes)
  		this.cancelAddValue()
  	},
  	nameChanged()
  	{
  		if(this.node.title)
  		{
  			let nodes = this.$store.state.calculations.nodes
	  		let ind = nodes.findIndex((item)=>{return item.id == this.node.id})
	  		nodes[ind] = this.node
	  		this.$store.dispatch('calculations/setNodes',nodes)
  		}
  		
  	},
  	deleteBundle(id)
  	{  		
      this.node.logic_bundles = this.node.logic_bundles.filter(item=>item.id !==id)
  	},
  	getBundleTitle(id,index)
    {      
      let bundle = this.node.logic_bundles.find(item=>item.id == id)
      let first_condition = bundle.conditions[0]
      if(first_condition.selected_input)
      {
        return first_condition.selected_input.name
      }
      else
      {
        return "karşılaştırma "+(index+1)
      }
    },
  	updateCollapsed(data,index)
    {      
      
    },
  	testchange()
  	{
  		console.log(this.$store.state.calculations)
  		let ind = this.$store.state.calculations.customattributes.findIndex((item)=>item.id == this.node.condition_action.customattribute)
  		this.selected_customattribute = this.$store.state.calculations.customattributes[ind]
  	},
  	swapInputs()
  	{
  		let nodes = this.$store.state.calculations.nodes

  		let node_ind = nodes.findIndex((item)=>{return item.id == this.node.id})

  		if(nodes[node_ind].input1 || nodes[node_ind].input2)
  		{
  			let input1 = this.sanitizeArray(nodes[node_ind].input1)
  			let input2 = this.sanitizeArray(nodes[node_ind].input2)
  			nodes[node_ind].input1 = input2
  			nodes[node_ind].input2 = input1
  			this.$store.dispatch('calculations/setNodes',nodes)
  		}

  	},
  	deleteConnection(input,index)
  	{
  		
  		let connections = this.$store.state.calculations.connections
  		let nodes = this.$store.state.calculations.nodes
  		let ind = nodes.findIndex((item)=>{return item.id == this.node.id})
  		//if value
  		if(input.id=="value")
  		{
  			nodes[ind].input = nodes[ind].input.toSpliced(index,1) 
  		}
  		//if value
  		//if connection
  		else
  		{
  			let node_id = input.id

	  		//set connections
	  		let the_connection = connections.find((item)=>{
	  			return item.from ==node_id.toString() && item.to == this.node.id.toString()
	  		})
	  		connections = connections.filter(item=>item.id !==the_connection.id)  	
	  		this.$store.dispatch('calculations/setConnections',connections)  
	  		//set connections
	  		//set nodes
	  		
	  		nodes[ind].input = nodes[ind].input.filter(item=>item.connection_id !==the_connection.id)
	  		//set nodes
  		}
  		//if connection
  		//return false
  		
  		

  		
  		setTimeout(()=>{
  			this.$store.dispatch('calculations/setNodes',nodes)
  			this.$store.state.calculations.fromnode = null
  		},10) 		

  	},
  	deleteValue(input)
  	{

  		let nodes = this.$store.state.calculations.nodes
  		let ind = nodes.findIndex((item)=>{return item.id == this.node.id})
  		nodes[ind][input] = null
  		setTimeout(()=>{
  			if(input=='input1')
  			{
  				this.input1val = null
  			}
  			if(input=='input2')
  			{
  				this.input2val = null
  			}
  			this.$store.dispatch('calculations/setNodes',nodes)
  		},10) 
  	},
  	nodeinputValueChanged(e,input)
  	{
  		let nodes = this.$store.state.calculations.nodes
  		let ind = nodes.findIndex((item)=>{return item.id == this.node.id})
  		if(this.node[input])
  		{
  			console.log("input val set")
  			nodes[ind][input].value = e.value
  			this.$store.dispatch('calculations/setNodes',nodes)
  		}
  		else
  		{
  			console.log("input val not set")
  			let val_item = {value:e.value,type:"value"}
  			nodes[ind][input] = val_item
  			this.$store.dispatch('calculations/setNodes',nodes)

  		}
  		console.log(e)
  	},
  	showContent()
  	{
  		console.log(this.node)
  		
  		if(!this.show_content)
  		{
  			this.resolveInputs()
  		}
  		console.log(this.inputs)
  		setTimeout(()=>{
  				this.show_content = !this.show_content
		  		if(!this.show_content)
		  		{
		  			this.adding_variable = false
		  			this.new_value = null
		  		}
  		})
  		
  	},

   severeConnections(event)
   {
      this.$confirm.require({
          target: event.currentTarget,
          group: 'severeconnections',
          message: "Bağlantıları koparmak üzeresiniz!",
          header: this.$store.state.languages.lang_phrases.silme_uyarisi,
          icon: 'pi pi-exclamation-triangle',
          acceptClass: 'p-button-danger p-button-outlined',
          acceptLabel:this.$store.state.languages.lang_phrases.devam_et,
          rejectLabel:this.$store.state.languages.lang_phrases.iptal,
          accept: () => {
              this.submitSevereConnections()
          },
          reject: () => {              
          }
      });      
    },
    submitSevereConnections()
    {
    	console.log("submitSevereConnections")
    	let connections = this.$store.state.calculations.connections

    	console.log(connections)
    	console.log(this.node.id)
    	connections = connections.filter(item=>item.to !== this.node.id.toString())
    	connections = connections.filter(item=>item.from !== this.node.id.toString())
    	console.log(connections)
    	this.$store.dispatch('calculations/setConnections',connections)
    	let nodes = this.$store.state.calculations.nodes
    	let node_ind = nodes.findIndex((item)=>{return item.id == this.node.id})
    	nodes[node_ind].input = []
    	if(nodes[node_ind].type=="conditional_logic")
    	{
    		nodes[node_ind].logic_bundles = []
    	}
    	this.$store.dispatch('calculations/setNodes',nodes)
    },
    deleteNode(event)
   	{
      this.$confirm.require({
          target: event.currentTarget,
          group: 'deletenode',
          message: this.$store.state.languages.lang_phrases.bu_kaydi_silmek_istiyor_musunuz,
          header: this.$store.state.languages.lang_phrases.silme_uyarisi,
          icon: 'pi pi-exclamation-triangle',
          acceptClass: 'p-button-danger p-button-outlined',
          acceptLabel:this.$store.state.languages.lang_phrases.devam_et,
          rejectLabel:this.$store.state.languages.lang_phrases.iptal,
          accept: () => {
              this.submitDeleteBundle()
          },
          reject: () => {              
          }
      });      
    },
    submitDeleteBundle()
    {
    	let nodes = this.$store.state.calculations.nodes
    	let connections = this.$store.state.calculations.connections
    	let node_ind = nodes.findIndex((item)=>{return item.id == this.node.id})
    	this.show_content = false

    	console.log("deleteNode")
    	console.log(this.node)


    	if(this.node.type=="variable")
    	{
    		let output_cons = connections.filter((item)=>{return item.from==this.node.id})
    		for(let output_conn of output_cons)
    		{
    			connections = connections.filter((item)=>{return item.id !== output_conn.id})
    			this.$store.dispatch('calculations/setConnections',connections)
    		}
    		
    	}
    	else if(this.node.type=="equation")
    	{
    		let output_conns = connections.filter((item)=>{return item.from==this.node.id})
    		for(let output_conn of output_conns)
    		{
    			connections = connections.filter((item)=>{return item.id !== output_conn.id})
    		}

    		let input_conns = connections.filter((item)=>{return item.to==this.node.id})
    		for(let input_conn of input_conns)
    		{
    			connections = connections.filter((item)=>{return item.id !== input_conn.id})
    			this.$store.dispatch('calculations/setConnections',connections)
    		}
    		
    	}
    	else
    	{
    		let output_conns = connections.filter((item)=>{return item.from==this.node.id})
    		for(let output_conn of output_conns)
    		{
    			connections = connections.filter((item)=>{return item.id !== output_conn.id})
    		}
    		

    		let input_conns = connections.filter((item)=>{return item.to==this.node.id})

    		for(let input_conn of input_conns)
    		{
    			connections = connections.filter((item)=>{return item.id !== input_conn.id})
    		}
    		this.$store.dispatch('calculations/setConnections',connections)
    		
    	}

    	setTimeout(()=>{
    		nodes = nodes.filter((item)=>{return item.id !== nodes[node_ind].id})
    		this.$store.dispatch('calculations/setNodes',nodes)
    		this.$store.state.calculations.fromnode = null
    	},10)

    	
    },

  	
  }

}
</script>

<style lang="css" scoped>
	.select_area{
		justify-content: space-between;
	}
	.the_elipsis{
		max-width: 110px;
	}
</style>